import { render, staticRenderFns } from "./ModelWall.vue?vue&type=template&id=6d872df6&scoped=true"
import script from "./ModelWall.vue?vue&type=script&lang=js"
export * from "./ModelWall.vue?vue&type=script&lang=js"
import style0 from "./ModelWall.vue?vue&type=style&index=0&id=6d872df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d872df6",
  null
  
)

export default component.exports